import { createSetIntentType, getIntents } from '../intent';
export const createElementTransform = createSetIntentType('createElementTransform', (decorate)=>(transform)=>decorate(transform));
export function runElementTransforms(revision) {
    var _getIntents;
    (_getIntents = getIntents(createElementTransform, revision)) === null || _getIntents === void 0 ? void 0 : _getIntents.forEach((transform)=>transform(revision));
}

//# sourceMappingURL=element.js.map